type Stage = 'local' | 'local-prod' | 'tunnel' | 'dev' | 'prod';

const stage = (process.env.STAGE as Stage) || 'prod';
const version = process.env.VERSION || 'v3';

type Config = {
  version: string;
  domain: string;
  stage: string;
  rootDomain: string;
  isProduction: boolean;
  paymentPageUrl: string;
  cardInputUrl: string;
  paymentModalUrl: string;
  bizumUrl: string;
  bizumButtonUrl: string;
  paypalUrl: string;
  apiUrl: string;
  paymentRequestUrl: string;
  secureDomain: string;
};

const stageConfig: Record<Stage, Partial<Config>> = {
  local: {
    domain: 'http://card-input.localhost:1355',
    paymentPageUrl: 'http://payment-page.localhost:1355/',
    cardInputUrl: 'http://card-input.localhost:1355/',
    paymentModalUrl: 'http://payment-modal.localhost:1355/',
    paypalUrl: 'http://paypal.localhost:1355/',
    bizumUrl: 'http://bizum.localhost:1355/',
    bizumButtonUrl: 'http://bizum-button.localhost:1355/',
    paymentRequestUrl: 'http://payment-request.localhost:1355/',
    apiUrl: 'https://api.monei-dev.com/v1',
    secureDomain: 'https://secure.monei-dev.com',
    rootDomain: 'monei-dev.com'
  },
  'local-prod': {
    domain: 'http://card-input.localhost:1355',
    paymentPageUrl: 'http://payment-page.localhost:1355/',
    cardInputUrl: 'http://card-input.localhost:1355/',
    paymentModalUrl: 'http://payment-modal.localhost:1355/',
    paypalUrl: 'http://paypal.localhost:1355/',
    bizumUrl: 'http://bizum.localhost:1355/',
    bizumButtonUrl: 'http://bizum-button.localhost:1355/',
    paymentRequestUrl: 'http://payment-request.localhost:1355/',
    apiUrl: 'https://api.monei.com/v1',
    secureDomain: 'https://secure.monei.com',
    rootDomain: 'monei.com'
  },
  tunnel: {
    domain: 'https://card-input.monei-dev-tunnel.com',
    paymentPageUrl: 'https://payment-page.monei-dev-tunnel.com/',
    cardInputUrl: 'https://card-input.monei-dev-tunnel.com/',
    paymentModalUrl: 'https://payment-modal.monei-dev-tunnel.com/',
    paypalUrl: 'https://paypal.monei-dev-tunnel.com/',
    bizumUrl: 'https://bizum.monei-dev-tunnel.com/',
    bizumButtonUrl: 'https://bizum-button.monei-dev-tunnel.com/',
    paymentRequestUrl: 'https://payment-request.monei-dev-tunnel.com/',
    apiUrl: 'https://api.monei.com/v1',
    secureDomain: 'https://secure.monei.com',
    rootDomain: 'monei.com'
  },
  dev: {
    domain: process.env.DOMAIN || 'https://js.monei-dev.com',
    apiUrl: 'https://api.monei-dev.com/v1',
    secureDomain: 'https://secure.monei-dev.com',
    rootDomain: 'monei-dev.com'
  },
  prod: {
    domain: process.env.DOMAIN || 'https://js.monei.com',
    apiUrl: 'https://api.monei.com/v1',
    secureDomain: 'https://secure.monei.com',
    rootDomain: 'monei.com'
  }
};

const sc = stageConfig[stage];
const domain = sc.domain!;

const globalConfig = {
  domain,
  version,
  stage,
  isProduction: stage === 'prod',
  paymentPageUrl: sc.paymentPageUrl || `${domain}/${version}/payment-page/`,
  cardInputUrl: sc.cardInputUrl || `${domain}/${version}/inner-card-input/`,
  paymentModalUrl: sc.paymentModalUrl || `${domain}/${version}/inner-payment-modal/`,
  paypalUrl: sc.paypalUrl || `${domain}/${version}/inner-paypal/`,
  bizumUrl: sc.bizumUrl || `${domain}/${version}/inner-bizum/`,
  bizumButtonUrl: sc.bizumButtonUrl || `${domain}/${version}/inner-bizum-button/`,
  paymentRequestUrl: sc.paymentRequestUrl || `${domain}/${version}/inner-payment-request/`
};

export const config = {...globalConfig, ...sc} as Config;
